module.exports = __webpack_public_path__ + "img/電気回路_3_6_1.c6393d47.png";